/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_Done_BodyInputs */

const en_us2_profile_editors_export_done_body = /** @type {(inputs: Profile_Editors_Export_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your data was handed over for you to keep.`)
};

const pt_br2_profile_editors_export_done_body = /** @type {(inputs: Profile_Editors_Export_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus dados foram entregues para você guardar.`)
};

const es_419_profile_editors_export_done_body = /** @type {(inputs: Profile_Editors_Export_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus datos se entregaron para que los guardes.`)
};

const pt_pt2_profile_editors_export_done_body = /** @type {(inputs: Profile_Editors_Export_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os teus dados foram-te entregues para os guardares.`)
};

const fr_fr2_profile_editors_export_done_body = /** @type {(inputs: Profile_Editors_Export_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes données t'ont été remises pour que tu les gardes.`)
};

const de_de2_profile_editors_export_done_body = /** @type {(inputs: Profile_Editors_Export_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Daten wurden dir zum Aufbewahren übergeben.`)
};

const it_it2_profile_editors_export_done_body = /** @type {(inputs: Profile_Editors_Export_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi dati ti sono stati consegnati da conservare.`)
};

/**
* | output |
* | --- |
* | "Your data was handed over for you to keep." |
*
* @param {Profile_Editors_Export_Done_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_done_body = /** @type {((inputs?: Profile_Editors_Export_Done_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_Done_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_done_body(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_done_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_done_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_done_body(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_done_body(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_done_body(inputs)
	return en_us2_profile_editors_export_done_body(inputs)
});
export { profile_editors_export_done_body as "profile-editors.export_done_body" }